import React, { useState, useEffect } from 'react';

const SocialSidebar = ({ lang }) => {
  const isRtl = lang === 'ar';
  const whatsappNumber = "201070107397";

  // --- ميزة الاختفاء والظهور عند التمرير ---
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const controlSidebar = () => {
      if (window.scrollY > lastScrollY && window.scrollY > 200) { 
        setIsVisible(false); // يختفي عند النزول لأسفل
      } else { 
        setIsVisible(true);  // يظهر عند الصعود لأعلى
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener('scroll', controlSidebar);
    // التصحيح هنا: التأكد من تطابق اسم الدالة في الـ Cleanup
    return () => window.removeEventListener('scroll', controlSidebar);
  }, [lastScrollY]);
  // ---------------------------------------

  const socialLinks = [
    {
      id: 'wa',
      name: isRtl ? 'واتساب' : 'WhatsApp',
      url: `https://wa.me/${whatsappNumber}`,
      color: '#25D366',
      svg: "M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
    },
    {
      id: 'fb',
      name: 'Facebook',
      url: 'https://www.facebook.com/Yaminternationalindustries/',
      color: '#1877F2',
      svg: "M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"
    },
    {
      id: 'ig',
      name: 'Instagram',
      url: 'https://www.instagram.com/yam.egy24',
      color: '#E4405F',
      svg: "M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76c-.198.509-.333 1.09-.373 1.944C.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"
    },
    {
      id: 'li',
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/company/yam-international-industries',
      color: '#0077B5',
      svg: "M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"
    }
  ];

  return (
    <div style={{
      ...styles.sidebar,
      [isRtl ? 'right' : 'left']: '12px',
      opacity: isVisible ? 1 : 0,
      transform: `translateY(-50%) translateX(${isVisible ? '0' : (isRtl ? '60px' : '-60px')})`,
      transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
      pointerEvents: isVisible ? 'all' : 'none'
    }}>
      {socialLinks.map((item) => (
        <a 
          key={item.id}
          href={item.url}
          target="_blank"
          rel="noreferrer"
          className="social-anchor-integrated"
          style={{'--brand-color': item.color}}
        >
          <div style={styles.iconBox}>
            <svg width="20" height="20" fill="white" viewBox="0 0 16 16">
              <path d={item.svg}/>
            </svg>
          </div>
          <span className="social-text-integrated">{item.name}</span>
        </a>
      ))}

      <style>{`
        .social-anchor-integrated {
          width: 40px;
          height: 40px;
          border-radius: 50px;
          background: var(--brand-color);
          opacity: 0.85;
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          display: flex;
          align-items: center;
          text-decoration: none;
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          overflow: hidden;
          margin-bottom: 10px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.2);
        }

        .social-anchor-integrated:hover {
          width: 125px;
          opacity: 1;
          background: var(--brand-color);
          box-shadow: 0 8px 20px rgba(0,0,0,0.3);
          transform: scale(1.05);
        }

        .social-text-integrated {
          opacity: 0;
          transform: translateX(${isRtl ? '15px' : '-15px'});
          transition: all 0.3s ease;
          white-space: nowrap;
          color: white;
          font-size: 13px;
          font-weight: 700;
          padding: 0 10px;
        }

        .social-anchor-integrated:hover .social-text-integrated {
          opacity: 1;
          transform: translateX(0);
        }

        .social-anchor-integrated:hover svg {
          animation: wiggle 0.5s ease-in-out;
        }

        @keyframes wiggle {
          25% { transform: rotate(10deg); }
          75% { transform: rotate(-10deg); }
        }

        @media (max-width: 768px) {
           .social-anchor-integrated {
             width: 35px;
             height: 35px;
           }
           .social-anchor-integrated:hover {
             width: 35px;
           }
           .social-text-integrated { display: none; }
        }
      `}</style>
    </div>
  );
};

const styles = {
  sidebar: {
    position: 'fixed',
    top: '50%',
    zIndex: 10002,
    display: 'flex',
    flexDirection: 'column',
  },
  iconBox: {
    minWidth: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
};

export default SocialSidebar;